<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { approveEmail } from "./utils";

  export let kind;

  const onclick = async () => approveEmail();
</script>

<ButtonWithTooltip
  {kind}
  leadingIcon="fa-regular fa-check"
  class="flex-1"
  {onclick}
  size="large"
  placement="top"
>
  <span slot="tooltip"
    >Schedule this email to be sent<br />and continue outreach</span
  >
  Approve
</ButtonWithTooltip>
